import React, { useState } from 'react';
import { Modal } from 'antd';
import ReactDOM from 'react-dom';

import {
	ButtonWrapper,
	Info,
	ModalContent,
	Question,
	Title,
	Warning,
} from './styles';

import Button from '../../../../../Button';
import Divider from '../../../../../Divider';

import warningIcon from '../../../../../../assets/warning_icon.png';

import { getElementNode } from '../../../../../../services/elementNode';

const OverLimitWarningModal = (props) => {
	const { callback, info } = props;

	const [visible, setVisible] = useState(true);

	const handleClose = (action) => {
		setVisible(false);

		callback(action);
	}

  return (
    <Modal
      visible={visible}
      onOk={() => handleClose()}
      onCancel={() => handleClose()}
      footer={null}
      closeIcon={<div />}
      width={700}
    >
      <ModalContent>
        <Warning src={warningIcon} alt="warning" />
        <Title>Fotos acima do limite</Title>
        <Info>
          {info}
        </Info>

				<Divider size="small" />

        <Question>
          <b>O que deseja fazer?</b>
        </Question>
        <Button block onClick={() => handleClose('continue')}>
					CONTINUAR
        </Button>
        <ButtonWrapper>
          <Button block onClick={() => handleClose('cancel')}>
            CANCELAR ENVIO
          </Button>
        </ButtonWrapper>
      </ModalContent>
    </Modal>
  );
};

OverLimitWarningModal.open = async (info) => {
  const overLimitWarningModalNode = getElementNode("over-limit-warning-modal");
	
	return new Promise((resolve) => {
		ReactDOM.render(
			<OverLimitWarningModal
				callback={resolve}
				info={info}
			/>,
			overLimitWarningModalNode
			);
	})
}

export default OverLimitWarningModal;
